/**
 * Creates an AddToCartRequest from product details and quantity.
 */
export const createAddToCartRequestFromProduct = (product, quantity = 1, creatorAttributionToken) => {
    var _a, _b, _c;
    if (!isValidForCart(product.asin, (_a = product.offerDetails) === null || _a === void 0 ? void 0 : _a.selectedOfferId, quantity)) {
        return undefined;
    }
    return createAddToCartRequestFromInputFields(product.asin, product.offerDetails.selectedOfferId, quantity, { currency: ((_b = product.price) === null || _b === void 0 ? void 0 : _b.currencyCode) || '', amount: ((_c = product.price) === null || _c === void 0 ? void 0 : _c.amount) || 0 }, creatorAttributionToken);
};
/**
 * Creates an AddToCartRequest from bag contents using the first item.
 * This is specifically hardcoded to use one item only, and will need to change for multi-ASIN checkout.
 */
export const createAddToCartRequestFromBag = (bagContents, creatorAttributionToken) => {
    var _a, _b;
    const product = bagContents[0];
    if (!isValidForCart(product === null || product === void 0 ? void 0 : product.asin, product === null || product === void 0 ? void 0 : product.selectedOfferId, product === null || product === void 0 ? void 0 : product.quantity)) {
        return undefined;
    }
    return createAddToCartRequestFromInputFields(product.asin, product.selectedOfferId, product.quantity, { currency: ((_a = product.price) === null || _a === void 0 ? void 0 : _a.currency) || '', amount: ((_b = product.price) === null || _b === void 0 ? void 0 : _b.amount) || 0 }, creatorAttributionToken);
};
/**
 * Validates if an item has required fields for adding to cart.
 */
const isValidForCart = (asin, selectedOfferId, quantity) => !!asin && !!selectedOfferId && !!quantity && quantity > 0;
const createAddToCartRequestFromInputFields = (asin, selectedOfferId, quantity, price, creatorAttributionToken) => (Object.assign({ cartItemRequests: [{ asin, selectedOfferId, quantity, price }] }, (creatorAttributionToken && { creatorAttributionToken })));
